import { EmployeeType } from '@/models/employee';
import { IUser, IUserData, User } from '@/models/user';
import { IPayrollChangeRequestPaginatedListData } from '@/services';
import { PayrollChangeRequest } from '../payrollchangerequest';
import {
  IPayrollChangeRequestData,
  IPayrollChangeRequest
} from '../payrollchangerequest.types';

export const mockPayrollChangeRequestsData = (): IPayrollChangeRequestData[] => [
  {
    id: 1,
    owner: {
      first_name: 'Lamar',
      last_name: 'Falconer',
      email: 'lfalconer@gmail.com'
    },
    employee: {
      id: 6,
      first_name: 'ewfd',
      last_name: 'dfs',
      title: '',
      employee_number: '5432',
      is_active: true,
      supervisor: null,
      type: EmployeeType.Hourly
    },
    from_department: {
      id: 61,
      code: '102',
      name: 'Press'
    },
    to_department: {
      id: 63,
      code: '104',
      name: 'Controls'
    },
    from_group: {
      id: 1,
      name: 'Technical Associate I',
      description: ''
    },
    to_group: {
      id: 1,
      name: 'Technical Associate II',
      description: ''
    },
    from_rate: 68,
    to_rate: 9876,
    reason: 'reason',
    effective_date: '2022-08-04',
    additional_info: 'jkhgfdsxz',
    created_at: '2022-08-04T15:55:47.307238Z',
    updated_at: '2022-08-04T15:55:47.307269Z'
  }
];

export const mockPayrollChangeRequestHRPersonnelsData = (): IUserData[] => [
  {
    first_name: 'Lamar',
    last_name: 'Falconer',
    email: 'lfalconer@gmail.com'
  }
];

export const mockPayrollChangeRequests = (
  data: IPayrollChangeRequestData[] = mockPayrollChangeRequestsData()
): IPayrollChangeRequest[] => data.map(item => new PayrollChangeRequest(item));

export const mockPayrollChangeRequestHRPersonnels = (
  data: IUserData[] = mockPayrollChangeRequestHRPersonnelsData()
): IUser[] => data.map(item => new User(item));

export const mockPayrollChangeRequestPaginatedData = (): IPayrollChangeRequestPaginatedListData => {
  return {
    count: mockPayrollChangeRequestsData().length,
    next: '',
    previous: '',
    results: mockPayrollChangeRequestsData()
  };
};
